// eslint-disable-next-line import/no-extraneous-dependencies
import { createAction } from 'redux-actions';

export const getListDepartmentRequest = createAction(
  'GET_LIST_DEPARTMENT_REQUEST',
);
export const getListDepartmentSuccess = createAction(
  'GET_LIST_DEPARTMENT_SUCCESS',
);
export const getListDepartmentFailure = createAction(
  'GET_LIST_DEPARTMENT_FAILURE',
);

export const createDepartmentRequest = createAction('CREATE_DEPARTMENT_REQUEST');
export const createDepartmentSuccess = createAction('CREATE_DEPARTMENT_SUCCESS');
export const createDepartmentFailure = createAction('CREATE_DEPARTMENT_FAILURE');
export const resetCreateDepartment = createAction('RESET_CREATE_DEPARTMENT');

export const updateDepartmentRequest = createAction('UPDATE_DEPARTMENT_REQUEST');
export const updateDepartmentSuccess = createAction('UPDATE_DEPARTMENT_SUCCESS');
export const updateDepartmentFailure = createAction('UPDATE_DEPARTMENT_FAILURE');
export const resetUpdateDepartment = createAction('RESET_UPDATE_DEPARTMENT');

export const deleteDepartmentRequest = createAction('DELETE_DEPARTMENT_REQUEST');
export const deleteDepartmentSuccess = createAction('DELETE_DEPARTMENT_SUCCESS');
export const deleteDepartmentFailure = createAction('DELETE_DEPARTMENT_FAILURE');
export const resetDeleteDepartment = createAction('RESET_DELETE_DEPARTMENT');

export const getDetailDepartmentRequest = createAction('GET_DEPARTMENT_REQUEST');
export const getDetailDepartmentSuccess = createAction('GET_DEPARTMENT_SUCCESS');
export const getDetailDepartmentFailure = createAction('GET_DEPARTMENT_FAILURE');
export const resetDetailDepartment = createAction('RESET_DETAIL_DEPARTMENT');

export const resetDepartmentsState = createAction('RESET_DEPARTMENTS_STATE');
